export const getDefaultPageSize = () => Number(localStorage.getItem('pageSize')) || 20;
export const PAGE_SIZES = [5, 10, 20, 50, 100];
export const PAGE_SIZE_STEP = 1;
export const COMMA_SEPERATED_EMAIL_REGEX =
  /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s*?)([\s,;]+[\s]*?[^\s,]+@[^\s,]+\.[^\s,]+\s*?)*$/;
export const IP_REGEX = /^(?=.*[^.]$)((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.?){4}$/;
export const GUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
export const DOMAIN_REGEX = /^([a-zA-ZÀ-ÿ0-9-_]+\.)+[a-zA-Z]{2,}$/;
